import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { TelegramChannelService } from '../../../_services/telegram-channel.service';
import { TelegramChannelModel } from '../../../_models/telegram-channel';

@Component({
    selector: 'app-add-telegram-channel',
    templateUrl: './add-telegram-channel.component.html',
    styleUrls: ['./add-telegram-channel.component.css']
})

export class AddTelegramChannelComponent extends DialogComponent<TelegramChannelModel, boolean> implements OnInit {
    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    id: number;
    nameTelegramChannel: string;
    idTelegramChannel: string;
    linkTelegramChannel: string;
    type: number = 1; // default type telegram corresponds to the Line Bot
    typeArray : any[] = [
        {'value' : 1, 'text' : "ラインボットと該当なテレグラムチャネル"},
        {'value' : 2, 'text' : "他のテレグラムチャネル"}
    ];
    lineBotId: number = 6; // default id of Bitlion
    lineBotAll: any[];
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService,
        private telegramChannelService: TelegramChannelService,
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.model.id = this.id;
        this.model.nameTelegramChannel = this.nameTelegramChannel;
        this.model.idTelegramChannel = this.idTelegramChannel;
        this.model.linkTelegramChannel = this.linkTelegramChannel;
        this.model.type = this.type;
        this.model.lineBotId = this.lineBotId;
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    save() {
        this.loading = true;
        this.message = '';
        this.telegramChannelService.save(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }

    onChangeDefault($event) {
        // when change type = 1 (the telegram channel corresponds to the Line) and lineBotId = 0 (choose Line bot) then disable submit button
        this.message = '';
        if (this.model.type == 1 && this.model.lineBotId == 0) {
            this.loading = true;
        } else {
            this.loading = false;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/telegram-channel/add-telegram-channel/add-telegram-channel.component.ts